export interface IProfile {
    badAddress: boolean;
    birthday: string;
    cellPhone: string;
    city: string;
    countryId: number;
    directoryStatus: string;
    email: string;
    emailOptOut: boolean;
    firstName: string;
    homePhone: string;
    lastName: string;
    line1: string;
    line2: string;
    line3: string;
    middleName: string;
    personId: number;
    smsOptIn: boolean;
    cmpOptIn: boolean;
    cmpOptOut: boolean;
    ssn: string;
    stateProvince: string;
    suffix: string;
    underNBRCJE: boolean;
    workPhone: string;
    zip: string;
    zipPlus4: string;
    ccpCycleBegin: string;
    ccpCycleEnd: string;
    contactNBRC: boolean;
    badPayment: boolean;
    cmpDashBoard: boolean;
    allowCmpOptInOrOut: boolean;
    scheduledExams: boolean;
    showBadge: boolean;
    badEmail: boolean;
    reviewProfile: boolean;
    reviewDemographics: boolean;
}

export class Profile implements IProfile {
    badAddress: boolean;
    birthday: string;
    cellPhone: string;
    city: string;
    countryId: number;
    directoryStatus: string;
    email: string;
    emailOptOut: boolean;
    firstName: string;
    homePhone: string;
    lastName: string;
    line1: string;
    line2: string;
    line3: string;
    middleName: string;
    personId: number;
    smsOptIn: boolean;
    cmpOptIn: boolean;
    cmpOptOut: boolean;
    ssn: string;
    stateProvince: string;
    suffix: string;
    underNBRCJE: boolean;
    workPhone: string;
    zip: string;
    zipPlus4: string;
    ccpCycleBegin: string;
    ccpCycleEnd: string;
    ccpStatus: any;
    contactNBRC: boolean;
    badPayment: boolean;
    cmpDashBoard: boolean;
    allowCmpOptInOrOut: boolean;
    scheduledExams: boolean;
    showBadge: boolean;
    badEmail: boolean;
    reviewProfile: boolean;
    reviewDemographics: boolean;
}
